//
// CallControlsDisplay - Displays call control information and buttons
// Shows case details, caller information, and call management controls
//
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {
  useCallback,
  useEffect,
  useState,
  useMemo,
} from 'react';

import {
  TelephoneHangupBase,
} from '../../assets/js/svg/gui';
import {
  useCalls,
  useSingleCase,
  useTownAssets,
} from '../../stores';
import { displayJson } from '../../utils';
import CaseControlsButtons from '../cases/CaseControlsButtons';
import CategoryIcon from '../CategoryIcon';
import {
  Row,
  Column,
} from '../display';
import {
  CsLvlColorDiv,
} from '../generic';

function CallControlsDisplay(props) {
  const {
    setCaseSelected,
  } = props;
  const { thisCase } = useSingleCase();
  const { calls } = useCalls() || {};
  const { assets } = useTownAssets();
  const {
    cuid,
    csid,
    // crUid,
    csUid,
    ccatCode,
    // cDatim1,
    // rDatim1,
    // emergency,
    csLvl,
    csClose,
    csHold,
    csBtwnUsrs,
    csUsrsCflct,
    // csReject,
    // crLDatim,
    // numWounded,
    // numDead,
    // csHandlers,
    // csUsersSolv,
    // csUsersCncl,
    // csDeath,
    // csVlnc,
    // csWounds,
    // csWeapon,
    participants,
  } = thisCase;
  const {
    translate,
  } = assets;
  const {
    active,
  } = calls;
  // const [callInfo, setCallInfo] = useState();
  const [caller, setCaller] = useState();

  // useEffect(
  //   () => {
  //     console.log(`CallControlsDisplay calls.active = ${displayJson(calls.active)}`);
  //   },
  //   [calls.active],
  // );

  useEffect(
    () => {
      if (calls.active
        && (!caller)
        && (participants)) {
        participants.some((thisParticipant) => {
          if ((thisParticipant.crUid !== active.reqCrUid)
              && (thisParticipant.crUid !== active.ackCrUid)) {
            return false;
          }

          let name = thisParticipant.crFname;
          if (thisParticipant.crMdlsfx) name += ` (${thisParticipant.crMdlsfx})`;
          name += ` ${thisParticipant.crLname}`;
          if (thisParticipant.crMdnname) name += ` (${thisParticipant.crMdnname})`;

          setCaller({
            ...thisParticipant,
            name,
          });
          return true;
        });
      } else if (caller
                && ((!calls.active)
                    || (!participants))) {
        setCaller();
      }
    },
    [active.ackCrUid, active.reqCrUid, caller, calls.active, participants],
  );

  const hangup = useCallback(
    () => {
      console.log(`hangup calls.active = ${displayJson(calls.active)}`);
      console.log(`hangup thisCase= ${displayJson(thisCase)}`);
      calls.end();
    },
    [calls, thisCase],
  );

  const title = useMemo(
    () => ((calls.active && calls.active.sts === 'on')
      ? translate('callOngoing')
      : `${translate('callPending')}...`),
    [calls.active, translate],
  );

  const selectCase = useCallback(
    () => {
      if (cuid && csid) setCaseSelected({ cuid, csid });

      console.log(`CallControlsDisplay thisCase=${displayJson(thisCase)}`);
    },
    [cuid, csid, setCaseSelected, thisCase],
  );

  const endButtonLabel = useMemo(
    () => ((calls.active && calls.active.sts === 'on')
      ? translate('end')
      : translate('cancel')),
    [calls.active, translate],
  );

  const categoryTranslated = useMemo(
    () => ((ccatCode)
      ? translate(ccatCode, 'userMainMenu')
      : translate('notSelected', 'userMainMenu')),
    [ccatCode, translate],
  );

  if (!csid) return null;

  return (
    <Column>
      <div className={classNames(
        'w-full text-center bg-pxMainMenuBgndHaze px-1.5',
        {
          blink50: calls.active && calls.active.sts !== 'on',
        },
      )}
      >
        <b>{title}</b>
      </div>

      <Row className="bg-pxInitBgnd text-pxMainMenuItemSel h-20 w-full px-1.5 text-sm font-normal">

        <CsLvlColorDiv
          csLvl={csLvl}
          csClose={csClose}
          csHold={csHold}
          csBtwnUsrs={csBtwnUsrs}
          csUsrsCflct={csUsrsCflct}
          className="h-12 w-2"
        />

        <button
          type="button"
          onClick={selectCase}
          className="h-12 w-12 bg-white p-1 flex items-center justify-center"
        >
          <CategoryIcon category={ccatCode} />
        </button>

        <Column crossStart className="px-1.5 whitespace-nowrap">
          <span className="whitespace-nowrap mr-1">
            {`${translate('case')} #${csUid}`}
          </span>
          <span className="whitespace-nowrap mr-1">
            {categoryTranslated}
          </span>
        </Column>

        <div className="h-full px-2">
          <div className="h-full w-0.5 bg-pxMainMenuItemSel opacity-30" />
        </div>

        {
          (caller)
            ? (
                <>
                  <Column crossStart className="px-1.5 whitespace-nowrap">
                    <span className="whitespace-nowrap mr-1">
                      <b>{`${caller.name}`}</b>
                    </span>
                  </Column>

                  <div className="h-full px-2">
                    <div className="h-full w-0.5 bg-pxMainMenuItemSel opacity-30" />
                  </div>
                </>
              )
            : null
        }

        <CaseControlsButtons
          onClick={hangup}
          name="end"
          label={endButtonLabel}
        >
          <TelephoneHangupBase />
        </CaseControlsButtons>

      </Row>
    </Column>
  );
}

CallControlsDisplay.propTypes = {
  setCaseSelected: PropTypes.func.isRequired,
};

export default CallControlsDisplay;
